import { Controller, Menu, Toolbar, UseBefore } from '@tencent/workbench';
import { TOOLBAR_ITEMS, config } from './config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import { ExportFileFeature } from '../export-file/export-file-feature';
import { ExportNoPermissionMiddleware } from '../../middleware/export-no-permission-tooltip';
import BaseToolbarFeature from '../../common/feature/base-toolbar-feature';
import { browser } from '@src/slide/application/service/edit-extension/edit-extension-export';
import appConfigInstance from '@src/slide/infrastructure/module/dependent/config/tob/app-config';
import { ToolbarFileMenuConfig } from '@src/slide/infrastructure/module/dependent/config/config-manager-constants';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
})
export class ExportImageController extends BaseToolbarFeature {
    public constructor(private readonly exportFileFeature: ExportFileFeature) {
        super();
    }

    @Toolbar(config.id, 'onClick')
    @Toolbar(wrapIdForBig(config.id), 'onClick')
    @Menu(config.id, 'onClick')
    public onClick() {
        this.exportFileFeature.exportImage({
            position: 'toolbar',
        });
    }


    @Toolbar(config.id, 'tooltip')
    @Toolbar(wrapIdForBig(config.id), 'tooltip')
    @UseBefore(ExportNoPermissionMiddleware)
    public authHoverTips() {
        return config.tipMsg;
    }

    @Toolbar(config.id, 'shouldDisabled')
    @Toolbar(wrapIdForBig(config.id), 'shouldDisabled')
    @Menu(config.id, 'shouldDisabled')
    public shouldDisabled() {
        return this.exportFileFeature.shouldDisabled(config.id);
    }

    @Toolbar(config.id, 'shouldHide')
    @Toolbar(wrapIdForBig(config.id), 'shouldHide')
    @Menu(config.id, 'shouldHide')
    public shouldHide() {
        return !(appConfigInstance.getConfig(ToolbarFileMenuConfig.exportImg as any) ?? true)
            || browser.isWxMiniProgram;
    }
}

